import {React} from 'react'
import { useState,useEffect} from "react";
import Wrapper from "../../components/UI/Wrapper";
import axios from "axios";
import "../../components/PaymentDetails/paymentDetails.css"

const PaymentDetails = ({ Relocation_Id }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const baseAPI = process.env.REACT_APP_API_URL;

  // Fetch rows data from the API
  useEffect(() => {
    const fetchRows = async () => {
      try {
        const storedToken = JSON.parse(localStorage.getItem("token"));
        if (!Relocation_Id) {
          console.error("Relocation_ID is not defined");
          alert("Relocation_ID is not available. Please check the data.");
          return;
        }
        const response = await axios.get(
          `${baseAPI}userget/GetSOW?relocation_id=${Relocation_Id}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );
        console.log("API Response:", response.data);
        // Extract the `data` property from the API response
        const data = response.data?.data || [];
        setRows(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching rows data:", error);
        setRows([]); // Fallback to an empty array on error
        setLoading(false);
      }
    };

    fetchRows();
  }, [Relocation_Id, baseAPI]);

  const handleVendorChange = (index, value) => {
    const newRows = [...rows];
    newRows[index].Vendor_id = value; // Updated to match the JSON key
    setRows(newRows);
  };

  const handleFileChange = (index, file) => {
    const newRows = [...rows];
    newRows[index].Receipt = file; // Updated to match the JSON key
    setRows(newRows);
  };

// POST API

const handleUpload = async (index) => {
  const storedToken = JSON.parse(localStorage.getItem("token"));
  const row = rows[index];

  if (!row.Receipt) {
    alert("Please select a file before uploading.");
    return;
  }

const formData = new FormData();
formData.append("Relocation_id", Relocation_Id);
formData.append("Vendor_id", row.Vendor_id || ""); 
formData.append("Receipt", row.Receipt); 
formData.append("doc_name", row.Receipt);
formData.append("Is_Active", true); // Assuming Is_Active is always set to 1
formData.append("Temp_ID", row.Temp_ID); // Add Temp_ID here


  try {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    const response = await axios.post(
      `${baseAPI}UserPost/ScopeOfWorkReceipt`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${storedToken}`,
          "Content-Type": "multipart/form-data",
          // Don't set Content-Type header here
        },
      }
    );

    if (response.data.status === "True") {
      alert("File uploaded successfully!");
    } else {
      alert(`Upload failed: ${response.data.message || "Unknown error"}`);
    }
  } catch (error) {
    console.error("Error uploading file:", error);
    alert(`An error occurred while uploading. Please try again.\nError: ${error.response?.data?.message || error.message}`);
  }
};

// POST API Call


  // Styles
  const rowColorChange = (index) => ({
    backgroundColor: index % 2 === 0 ? "#f6f3ff" : "white",
    color: "black",
  });

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Wrapper className="scop_Of_Work_wrapper">
      <div className="scope-of-work">
        <h2 style={{ fontSize: "20px", padding: "10px" }}>Scope Of Work</h2>
        <table className="table">
          <thead>
            <tr className="scop_of_work_tr_th">
              <th>S.No</th>
              <th>Service</th>
              <th>Status</th>
              <th>Remark</th>
              <th>Vendor</th>
              <th colSpan={2}>Related Document</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(rows) &&
              rows.map((row, index) => (
                <tr key={row.Temp_ID} style={rowColorChange(index)}>
                  <td style={rowColorChange(index )}>
                  {/* {String(index + 1).padStart(2, "0")} */}
                    {String(row.Temp_ID).padStart(2, "0")}
                  </td>
                  <td style={rowColorChange(index)}>{row.Service}</td>
                  <td
                    style={rowColorChange(index)}
                    className={
                      row.Status === "REQUIRED"
                        ? "status-required"
                        : "status-not-required"
                    }
                  >
                    {row.Status}
                  </td>
                  <td style={rowColorChange(index)}>{row.Remark}</td>
                  <td style={rowColorChange(index)}>
                    <select
                      style={{
                        ...rowColorChange(index),
                        width: "13rem",
                        height: "2.5rem",
                        borderRadius: "7.5px",
                      }}
                      value={row.Vendor_id || ""}
                      onChange={(e) => handleVendorChange(index, e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="Arun 	Srivasatv">Arun 	Srivasatv</option>
                      <option value="Aayushi	Aggarwal">Aayushi	Aggarwal</option>
                      <option value="Arun	Srivastava">Arun	Srivastava</option>
<option value="Mukul	Sharma">Mukul	Sharma</option>
<option value="Uthappa	Ganapathy">Uthappa	Ganapathy </option>
<option value="Aziz Ur	Rehman">Aziz Ur	Rehman</option>
<option value="SCOOBEE PET CAGES	PRIVATE LIMITED">SCOOBEE PET CAGES	PRIVATE LIMITED</option>
                    </select>
                  </td>
                  <td style={rowColorChange(index)}>
                    <input
                      style={{
                        border: "1px solid ",
                        borderRadius: "7.5px 0 0 7.5px",
                      }}
                      type="file"
                      onChange={(e) =>
                        handleFileChange(index, e.target.files[0])
                      }
                    />
                  </td>
                  <td style={rowColorChange(index)}>
                    <button
                      style={{
                        ...rowColorChange(index),
                        borderRadius: "0 7.5px 7.5px 0",
                        height: "2.4rem",
                      }}
                      className="upload-button"
                      onClick={() => handleUpload(index)}
                    >
                      Upload
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <div
        className="scope-of-work1"
        style={{ padding: "0 15px 26px 15px" }}
      >
        <div
          style={{
            background: "rgb(246, 243, 255)",
            padding: "12px 2px 1px 9px",
          }}
        >
          <h3
            style={{
              fontSize: "15px",
              padding: "3px 0 0 0",
              fontWeight: "600",
            }}
          >
            Other Requirement
          </h3>
          <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of
            type and scrambled it to make a type specimen book. It has
            survived not only five centuries, but also the leap into
            electronic typesetting, remaining essentially unchanged.
          </p>
        </div>
      </div>
    </Wrapper>
  );
};


export default PaymentDetails